import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ReplyTypeForm from '../../../components/forms/ReplyTypeForm';
import { useReplyTypeApi } from '../../../hooks/useReplyTypeApi';
import { useNavigate } from 'react-router-dom';
import { ReplyTypeDTO } from '../../../services/apiClient';

const ReplyTypeCreate: React.FC = () => {
  const { create, isLoading } = useReplyTypeApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Reply Types', href: '/admin/replytypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ReplyTypeDTO) => {
    try {
      await create(data);
      navigate('/admin/replytypes');
    } catch (error) {
      console.error('Error creating ReplyType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/replytypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ReplyType.Edit'
    >
        <ReplyTypeForm
          initialValues={{} as ReplyTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/replytypes')}
        />
    </AdminLayout>
  );
};

export default ReplyTypeCreate;